<template>
  <div class="app">
    <AppHeader fixed>
      <router-link class="navbar-brand" to="/">
        <img class="navbar-brand-full img-fluid" src="img/logo.png" alt="CoreUI Logo">
        <img class="navbar-brand-minimized img-fluid" src="img/logo.png" alt="CoreUI Logo">
      </router-link>

      <b-navbar-nav class="d-md-down-none"></b-navbar-nav>

      <b-navbar-nav class="ml-auto">

      </b-navbar-nav>

    </AppHeader>

    <div class="app-body">

      <main class="main">
        <router-view></router-view>
      </main>

    </div>

  </div>
</template>

<script>
  import {Header as AppHeader} from '@coreui/vue'

  export default {
    name: 'full',
    components: {AppHeader},
  }
</script>
<style scoped>

</style>
